import { createAsyncThunk } from '@reduxjs/toolkit';
import { MessageItem } from './slice';
import { AppAsyncThunkConfig } from 'store/store';
import { ServiceUserPatientProfile } from 'services/user-patient-profile';
import { NAMESPACE } from './helpers';

interface MessageForm {
  toPhoneNumber: string;
  whatsAppContentID: string;
  variables: string[];
}

export const actionPatientWhatsAppMessagesSendMessage = createAsyncThunk<
  void,
  { item: MessageItem; messageForm: MessageForm },
  AppAsyncThunkConfig
>(`${NAMESPACE}/sendMessage`, async (arg) => {
  const { item, messageForm } = arg;

  try {
    if (!item) {
      throw new Error('unexpected-behavior');
    }

    const input = {
      userPatientProfileID: String(item.formData.userPatientProfileID),
      toPhoneNumber: messageForm.toPhoneNumber,
      whatsAppContentID: messageForm.whatsAppContentID,
      variables: messageForm.variables,
    };
    
    await ServiceUserPatientProfile.sendWhatsApp(input);

    if (item.onSuccess) {
      item.onSuccess(input);
    }
  } catch (e) {
    if (item && item.onError) {
      item.onError(e);
    }
    throw e;
  }
});
